import AlertModal, { ALERT_VARIANT } from "../../components/alertModal/AlertModal";

/**
 * ErrorModals - presentational host for the server-not-responding and RTMS error modals.
 * All state and reset/restart transitions live in useSummarizationController; this component
 * only renders and forwards the user's choice. Spread the controller's `errorModals` bundle in.
 */
const ErrorModals = ({
  isServerErrorModalOpen,
  isRtmsErrorModalOpen,
  rtmsErrorType,
  onDismissServerError,
  onCancelRtmsError,
  onRestartRtmsError,
}) => (
  <>
    <AlertModal variant={ALERT_VARIANT.SERVER_NOT_RESPONDING} isOpen={isServerErrorModalOpen} onClose={onDismissServerError} />
    {rtmsErrorType && (
      <AlertModal
        variant={ALERT_VARIANT.RTMS_ERROR}
        isOpen={isRtmsErrorModalOpen}
        errorType={rtmsErrorType}
        onCancel={onCancelRtmsError}
        onRestart={onRestartRtmsError}
      />
    )}
  </>
);

export default ErrorModals;
